<template>
    <div class="max-container relative row" @click="closeSettingMenu($event)">
        <div class="col-12 breadcrumb-fixed">
            <BreadcrumbComponent />
        </div>

        <div class="col-12 md:col-4 xl:col-3 menu-fixed ">
            <MenuComponent />
        </div>

        <div class="col-12 md:col-8 xl:col-9 md:offset-4 xl:offset-3 content-fixed h-full">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
import MenuComponent from "./MenuComponent";
import BreadcrumbComponent from "../components/BreadcrumbComponent";
import appService from "../../../services/appService";
export default {
    name: "SettingsComponent",
    components: {MenuComponent, BreadcrumbComponent},

 methods: {
        closeSettingMenu: function (event) {
            return appService.closeSettingMenu(event);
        },
 }
}
</script>
